module.exports = __webpack_public_path__ + "static/img/apply-pfd.9fe2fe74.png";